/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagKindStringKeyRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TagKindStringKeyRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return TagKindStringKeyRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TagKindStringKeyRegexQueryOperator>): TagKindStringKeyRegexQueryOperator {
        let obj = Object.assign(new TagKindStringKeyRegexQueryOperator(), model);
        TagKindStringKeyRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagKindStringKeyRegexQueryOperator>): TagKindStringKeyRegexQueryOperator {
        if (!model) return null;
        return TagKindStringKeyRegexQueryOperator.newInstance(<TagKindStringKeyRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagKindStringKeyRegexQueryOperator) {
        if (!obj) return;

        models.TagKindStringKeyRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagKindStringKeyRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagKindStringKeyRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tag_key_regex) {
            models.Regex.fixupPrototype(this.tag_key_regex);
        }
    }

    /**
     * Namespace label key to identify which label to select
     */
    tag_kind: string;

    /**
     * Include responses where the label key has the given string
     */
    tag_key_regex: models.Regex;

}
